import React from 'react';

import FileTextIcon from '@rsuite/icons/legacy/FileText';
import ListIcon from '@rsuite/icons/List';
import PlusIcon from '@rsuite/icons/Plus';
import PeoplesIcon from '@rsuite/icons/Peoples';
import CalculatorIcon from '@rsuite/icons/legacy/Calculator';
import WarningIcon from '@rsuite/icons/legacy/Warning';
import TruckIcon from '@rsuite/icons/legacy/Truck';
import SearchIcon from '@rsuite/icons/Search';
import WechatIcon from '@rsuite/icons/Wechat';
import StarIcon from '@rsuite/icons/Star';
import InfoIcon from '@rsuite/icons/legacy/Info';

/**
 * Единый список разделов приложения для главной страницы и навигационного меню.
 * path — маршрут, titleKey — ключ перевода (namespace 'basic'), icon — имя иконки для меню.
 * Опционально для карточек на главной: topLeftComponent, topRightComponent (ReactNode), bg (CSS-класс).
 */
export const navSections = [
    {
        path: '/invoice',
        titleKey: 'nav_invoice',
        icon: 'FileText',
        topLeftComponent: <PlusIcon style={{ width: 28, height: 28 }} />,
        bg: 'homePage_cardBgGradient',
    },
    {
        path: '/template_list',
        titleKey: 'nav_templates',
        icon: 'List',
    },
    {
        path: '/contract_list',
        titleKey: 'nav_contracts',
        icon: 'FileText',
    },
{
        path: '/employee_list',
        titleKey: 'nav_employees',
        icon: 'Peoples',
    },
    {
        path: '/invoice_calculation',
        titleKey: 'nav_calculation',
        icon: 'Calculator',
    },
    {
        path: '/pretense',
        titleKey: 'nav_claim',
        icon: 'Warning',
    },
    {
        path: '/tracking_start',
        titleKey: 'nav_tracking',
        icon: 'Truck',
    },
    {
        path: '/notification_list',
        titleKey: 'notifications_title',
        icon: 'NoticeIcon',
    },
    {
        path: '/feedback',
        titleKey: 'nav_feedback',
        icon: 'Star',
    },
    {
        path: '/enter_chat',
        titleKey: 'nav_chat',
        icon: 'Wechat',
    },
    {
        path: '/instructions_list',
        titleKey: 'nav_instructions',
        icon: 'Info',
    },
    {
        path: '/profile',
        titleKey: 'nav_profile',
        icon: 'Member',
    }
];
